import type { z } from 'zod';

import { nationalClientIdentifierAnswersSchema } from '@/services/api/profile/national-client-identifier';
import type { PartialExcept } from '@/types/generics';

export const verificationInformationSchema = nationalClientIdentifierAnswersSchema;

export type VerificationInformation = z.infer<typeof verificationInformationSchema>;

export type VerificationInformationOrDefaults = VerificationInformation | PartialExcept<VerificationInformation, 'country'>;
